import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Button } from "@domestika-dev/prudencio/dist/atoms/Buttons";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Flex, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

export const LiveSessionScheduleFooter = ({
  cancelDisabled,
  submitDisabled,
  onCancel,
  onSubmit,
}) => (
  <GridItem gridRow={8} gridColumn="1 / span 8" marginTop={6}>
    <Flex width="100%" justifyContent="flex-end">
      <Button
        size="medium"
        hollow="secondary"
        marginRight={5}
        action={onCancel}
        disabled={cancelDisabled}
      >
        <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="sonar">
          <FormattedMessage id="live_sessions.schedule_new.cancel_button" />
        </Text>
      </Button>
      <Button size="medium" action={onSubmit} disabled={submitDisabled}>
        <Text size={["tiny", "tiny", "small"]} fontWeight="medium" color="coco">
          <FormattedMessage id="live_sessions.schedule_new.submit_button" />
        </Text>
      </Button>
    </Flex>
  </GridItem>
);

LiveSessionScheduleFooter.propTypes = {
  cancelDisabled: PropTypes.bool,
  submitDisabled: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

LiveSessionScheduleFooter.defaultProps = {
  cancelDisabled: false,
  submitDisabled: false,
};

export default LiveSessionScheduleFooter;
